import dayjs from 'dayjs';

export const MY_ASSETS_JOB_MAX_AGE_HOURS = 12;
export const MY_ASSETS_JOB_DISPLAY_LIMIT = 8;

export function parseJobDescription(job) {
  if (!job || !job.description) {
    return {};
  }
  try {
    return JSON.parse(job.description);
  } catch (_) {
    return {};
  }
}

export function isRecentJob(job, maxAgeHours = MY_ASSETS_JOB_MAX_AGE_HOURS) {
  if (!job || !job.created_at) {
    return false;
  }
  return dayjs().diff(dayjs(job.created_at), 'hour') < maxAgeHours;
}

export function isActiveJob(job) {
  return job && job.processed === 0 && !job.deleted_at;
}

export function isRunningJob(job) {
  return isActiveJob(job) && !!job.claimed_at && !job.on_hold;
}

export function isQueuedJob(job) {
  return isActiveJob(job) && (!job.claimed_at || job.on_hold);
}

export function isRunModelWorkJob(job) {
  const description = parseJobDescription(job);
  return Array.isArray(description.asset_ids) && description.asset_ids.length > 0;
}

export function filterRunModelJobs(jobs) {
  return (jobs || [])
    .filter((job) => isActiveJob(job))
    .filter((job) => isRecentJob(job))
    .filter((job) => isRunModelWorkJob(job));
}

export function filterLlmJobs(jobs) {
  return (jobs || []).filter((job) => isActiveJob(job)).filter((job) => isRecentJob(job));
}

export function collectAssetIdsFromJobs(jobs, limit = 20) {
  const ids = [];
  for (const job of jobs || []) {
    const description = parseJobDescription(job);
    if (description.asset_id) {
      ids.push(description.asset_id);
    }
    if (Array.isArray(description.asset_ids)) {
      ids.push(...description.asset_ids);
    }
    if (ids.length >= limit) {
      break;
    }
  }
  return [...new Set(ids)].slice(0, limit);
}

export function primaryAssetId(job) {
  const description = parseJobDescription(job);
  if (description.asset_id) {
    return description.asset_id;
  }
  if (Array.isArray(description.asset_ids) && description.asset_ids.length > 0) {
    return description.asset_ids[0];
  }
  return null;
}

export function assetCountForJob(job) {
  const description = parseJobDescription(job);
  if (description.asset_id) {
    return 1;
  }
  if (Array.isArray(description.asset_ids)) {
    return description.asset_ids.length;
  }
  return 0;
}
